var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_60_",
    "data-name": "svgexport-6 (60)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.321,
    height: 15.218,
    viewBox: "0 0 13.321 15.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10612",
    "data-name": "Group 10612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11066",
    "data-name": "Path 11066",
    d: "M45.239,6.661a6.66,6.66,0,1,0-8.49,6.406,1,1,0,0,1,.6.461l.846,1.467a.448.448,0,0,0,.777,0l.846-1.467a1,1,0,0,1,.595-.461A6.663,6.663,0,0,0,45.239,6.661Z",
    transform: "translate(-31.918 0)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11067",
    "data-name": "Path 11067",
    d: "M232.813,0q-.334,0-.66.038a6.661,6.661,0,0,1,1.12,13.028,1,1,0,0,0-.595.461l-.525.911.32.556a.448.448,0,0,0,.777,0l.846-1.467a1,1,0,0,1,.595-.461A6.661,6.661,0,0,0,232.813,0Z",
    transform: "translate(-226.2 0)",
    fill: "#7852cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11068",
    "data-name": "Path 11068",
    d: "M224.675,97.006h-.263a.645.645,0,0,1-.644-.608l-.187-3.32a.964.964,0,1,1,1.924,0l-.187,3.32A.645.645,0,0,1,224.675,97.006Z",
    transform: "translate(-217.883 -89.324)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11069",
    "data-name": "Path 11069",
    d: "M247.641,92.06a.965.965,0,0,0-.256.034.964.964,0,0,1,.706.983L247.9,96.4a.645.645,0,0,1-.519.6.646.646,0,0,0,.124.012h.263a.645.645,0,0,0,.644-.608l.187-3.32A.964.964,0,0,0,247.641,92.06Z",
    transform: "translate(-240.981 -89.324)",
    fill: "#e2dfe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11070",
    "data-name": "Path 11070",
    d: "M233.365,294.348h-.418a.491.491,0,0,1-.491-.491v-.336a.491.491,0,0,1,.491-.491h.418a.491.491,0,0,1,.491.491v.336A.491.491,0,0,1,233.365,294.348Z",
    transform: "translate(-226.495 -284.32)",
    fill: "#f1f1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11071",
    "data-name": "Path 11071",
    d: "M247.849,293.03h-.418l-.047,0a.491.491,0,0,1,.444.489v.336a.491.491,0,0,1-.444.489l.047,0h.418a.491.491,0,0,0,.491-.491v-.336A.491.491,0,0,0,247.849,293.03Z",
    transform: "translate(-240.98 -284.32)",
    fill: "#e2dfe2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.fcd26d9dc1e8215cd8746a819f750940.svg";
export { ForwardRef as ReactComponent };